export const APP_TITLE = import.meta.env.VITE_APP_TITLE || "OwnerFlow";
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "";
export const SOCKET_PORT = import.meta.env.VITE_SOCKET_PORT || "9000";
export const SITE_NAME = import.meta.env.VITE_SITE_NAME || "";
/** Cloudflare Turnstile *public* site key. The secret lives only in site config. */
export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY || "";

function readRouterBasename(): string {
  const meta = document.querySelector('meta[name="ownerflow-base-path"]')?.getAttribute("content");
  if (!meta || meta === "/") return "";
  return meta.replace(/\/$/, "");
}

/** Base path du routeur (vide = racine du site). Utilisé pour les liens HTML bruts (ex: popups Leaflet). */
export const ROUTER_BASENAME = readRouterBasename();

export const PAGE_SIZE = 20;
export const BOOKING_LIST_LIMIT = 500;
